export const errorToString = error => {
  const errorResponse = error?.response || null;
  const errorObject = errorResponse
    ? { status: errorResponse?.status || 500, statusText: errorResponse?.statusText, data: errorResponse?.data }
    : error;

  try {
    const errStr = JSON.stringify(errorObject);
    if (errStr === '{}') {
      return String(errorObject);
    } else {
      return errStr;
    }
  } catch (ex) {
    return String(errorObject);
  }
};
